<template>
  <div id="app">
    <router-view />
    <div id="message-box"></div>

    <div id="mloading" class="loading"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    const me = this;
  },
  mounted() {
    const me = this;

    me.initEnterSameTab();
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;
      
      window.addEventListener("keydown", function (e) {
        if (e.which === 13 && !e.shiftKey) {
          let tag = e.target.tagName.toLowerCase();
          if (["button", "a"].indexOf(tag) > -1) {
            return;
          }

          if ("textarea" == tag && e.shiftKey) {
            return;
          }
          //Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          //Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (
            e.target.closest(".ms-grid-viewer") &&
            e.target.closest("tbody")
          ) {
            return;
          }
          //ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest(".remain-focus-when-enter")) {
            return;
          }
          let focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>